module.exports = __webpack_public_path__ + "media/images/yardage_mark_5-7cd59ba1b6df91ee8e3339b4ca411c17.png";